/**
 * return indices of regexp matches in specified string
 * @param str
 * @param regexp
 * @returns number[]
 */
export const getRegexpIndices = (str: string, regexp: RegExp): number[] => {
  // FIXME could be done with matchAll, but it needs tsconfig es2020 and breaks in CI
  // return Array.from(placeholder.matchAll(regexp)).map(
  //   (res: any) => res.index
  // );
  let match
  let result = []
  while ((match = regexp.exec(str)) !== null) {
    result.push(match.index)
  }
  return result
}

/**
 * reformat specified string by adding separators automatically on correct indices
 * @param str
 * @param regexp
 * @param regexpIndices
 */
export const formatWithSeparators = (
  str: string,
  format: string,
  separator: string,
  regexp: RegExp,
  regexpIndices: number[],
) => {
  const cleanValue = str.replace(regexp, '')
  return Array.from(cleanValue).reduce((acc, letter) => {
    if (acc.length === format.length) return acc
    acc += letter
    for (let i = 0; i < regexpIndices.length; i++) {
      if (acc.length === regexpIndices[i]) {
        acc += separator
        break
      }
    }
    return acc
  }, '')
}
